export default __webpack_public_path__ + "static/media/obelisk.d4d171f4.png";